import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from "react-router-dom";
import "~src/App.css"
import "~src/assets/iconfont/iconfont.css"
import "lib-flexible"
import router from './route/index';
import {sensors} from "./utils/sensors_init"


const App = () => {
  useEffect(() => {
    sensors()
  },[])
  return <RouterProvider router={router} />
}
// ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<BrowserRouter>{OutputRoute()}</BrowserRouter>);
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
